
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/privacy-policy",
      function () {
        return require("private-next-pages/severalbrands/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/privacy-policy"])
      });
    }
  